import React, { useContext } from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import NearbyToursModal from 'tripPlanner/components/TripModal/ViewMoreOffers/NearbyToursModal'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  lat: number
  lng: number
  className?: string
  item: TripItem
  showSearch: boolean
}

function ViewNearbyToursCta({ lat, lng, item, className, showSearch }: Props) {
  const showModal = useContext(ModalContext)

  return (
    <TextButton
      kind="secondary"
      size="medium"
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showModal(
          <NearbyToursModal
            lat={lat}
            lng={lng}
            item={item}
            showSearch={showSearch}
          />,
        )
      }}
    >
      View more offers
    </TextButton>
  )
}

export default ViewNearbyToursCta
